import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopbarComponent } from './topbar/topbar.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { BetaNotificationDialog } from './beta-notification-dialog/beta-notification-dialog.component';
import { LayoutComponent } from './layout.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomerPrivacyModule } from './customer-privacy/customer-privacy.module';
import { FormsModule } from '@angular/forms';
import { SearchModule } from './topbar/search/search.module';
import { BannerModule } from './topbar/banner/banner.module';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileModule } from './topbar/profile/profile.module';
import { DevelopmentModule } from 'shared/development/development.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CeAccessModule } from 'shared/access/access.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LicenseNamePipeModule } from 'shared/pipes/license-name/license-name-pipe.module';
import { ReleaseInfoComponent } from './topbar/release-info/release-info.component';
import { TimeDisplayModule } from 'shared/time-display/time-display.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ServiceToolsCertificationDialogModule } from 'shared/dialogs/service-tools-certification-dialog/service-tools-certification-dialog.module';

@NgModule({
    declarations: [TopbarComponent, SidenavComponent, LayoutComponent, ReleaseInfoComponent, BetaNotificationDialog],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        RouterModule,
        FormsModule,
        MatSlideToggleModule,
        CustomerPrivacyModule,
        TranslateModule,
        MatMenuModule,
        SearchModule,
        BannerModule,
        ProfileModule,
        DevelopmentModule,
        MatProgressBarModule,
        CeAccessModule,
        MatTooltipModule,
        LicenseNamePipeModule,
        TimeDisplayModule,
        MatDialogModule,
        MatCheckboxModule,
        ServiceToolsCertificationDialogModule,
    ],
    exports: [LayoutComponent],
})
export class LayoutModule {}
